import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const drift = defineConnector({
  identifier: "drift",
  name: "Drift",
  tagLine: "Conversational marketing",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://driftapi\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Drift access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Drift, go to **Settings > App Settings > Developer** and create a new OAuth app, or use an existing access token from your app.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://driftapi.com/users/list",
  },
});
